"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const listEvaluatorsGroupsUseCase_1 = __importDefault(require("@/useCases/evaluators/listEvaluatorsGroupsUseCase"));
const selectors_1 = require("@/store/ducks/evaluators/selectors");
const index_view_1 = __importDefault(require("./index.view"));
function EvaluatorsHeadersTab() {
    const [currentTab, setTab] = react_1.default.useState(0);
    const dispatch = (0, react_redux_1.useDispatch)();
    const tabsData = (0, react_redux_1.useSelector)(selectors_1.siteTabsSelector);
    const areTabsLoading = (0, react_redux_1.useSelector)(selectors_1.areTabsLoadingSelector);
    const tabs = react_1.default.useMemo(() => {
        return tabsData.map((tab) => {
            return {
                label: tab.name,
                value: tab.id,
            };
        });
    }, [tabsData]);
    const onChangeTab = react_1.default.useCallback((event, newValue) => {
        setTab(newValue);
        if (event.target instanceof HTMLElement) {
            (0, listEvaluatorsGroupsUseCase_1.default)(event?.target?.dataset?.value)(dispatch);
        }
    }, [dispatch]);
    return (react_1.default.createElement(index_view_1.default, { tabs: tabs, isLoading: areTabsLoading, currentTab: currentTab, onChangeTab: onChangeTab }));
}
exports.default = EvaluatorsHeadersTab;
